import { useEffect, useRef, useState } from "react";

// Returns {key, diff} briefly whenever `value` grows by at least `min` (fractional gains accumulate).
export function useGainPop(value, { min = 0, duration = 1300 } = {}) {
  const prev = useRef(value);
  const acc = useRef(0);
  const [pop, setPop] = useState(null);
  useEffect(() => {
    const diff = (value || 0) - (prev.current || 0);
    prev.current = value;
    if (diff <= 0) { if (diff < 0) acc.current = 0; return; }
    acc.current += diff;
    if (acc.current < min || acc.current <= 0) return;
    setPop({ key: Date.now(), diff: acc.current });
    acc.current = 0;
  }, [value, min]);
  useEffect(() => {
    if (!pop) return;
    const t = setTimeout(() => setPop(null), duration);
    return () => clearTimeout(t);
  }, [pop, duration]);
  return pop;
}
